import Cookies from 'universal-cookie';
import { apiAdvcake } from '../app/constants/urls';

const ADVCAKE_SESSION_ID = 'advcake_session_id';
const ADVCAKE_TRACK_ID = 'advcake_track_id';
const ADVCAKE_TRACK_URL = 'advcake_track_url';

const cookies = new Cookies();

const advCakeCookies = {
  advcake_session_id:
    cookies.get(ADVCAKE_SESSION_ID) || '0session-id00-fail-0000-000000000000',
  advcake_track_id:
    cookies.get(ADVCAKE_TRACK_ID) || '000track-id00-fail-0000-000000000000',
  advcake_track_url: cookies.get(ADVCAKE_TRACK_URL) || '=fail of track url=',
};
export const getAdvCakeCookie = () => advCakeCookies;

export const sendAdvCakePostback = ({
  email,
  price,
  promocode = '',
  program,
}) => {
  const { advcake_track_id: trackId, advcake_track_url: url } =
    getAdvCakeCookie();

  try {
    fetch(apiAdvcake, {
      method: 'POST',
      body: JSON.stringify({
        email,
        price,
        promocode,
        trackId,
        url,
        program,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (error) {}
};
